// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

:root {
    --color-white: #fff;
    --color-main: #031B34;
    --color-main-fade: #1c3248;
    --color-secondary: #1c3248;
    --color-secondary-fade: #02162a;
    --color-button-hover: #03182f;
    --color-button-hover-fade: #03182f;
    --color-user-icon: #8e0000;
    --color-groupings: #9aa4ae;
    --color-gpt-icon: #03182f;
    --color-black: #02101f;
    --color-user-menu-hover: #4f5f71;
    --color-text: #f5f9ff;
    --color-gpt3: #03182f;
    --color-gpt4: #f22626;
    --color-secondary-p: #e6e8eb;
    --color-logo: #cdd1d6;
    --color-model-name: #e6e8eb;
    --color-assistant-bg: #9aa4ae;
    --color-assistant-text: #e6e8eb;
    --color-disclaimer: #e6e8eb;
    --color-border1: #35495d;
    --color-user-menu-border: #010810;
    --color-user-menu-selected-border: #010810;
    --color-border2: #010810;
    --color-user-message-border: #010810;
}

#askai_mainbody {
    /* background: var(--color-main); */
    display: flex;
    font-size: 1em;
    font-family: system-ui, sans-serif;
    height: 100vh;
    margin-top: 4rem;
}

#sidebar {
    position: relative;
    /* padding-top: 2rem; */
    left: 0;
    background: var(--color-secondary);
    padding: 4rem 0.8rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    transition: all 0.3s ease-in-out;
    /* height: 100vh; */
}

.float-top {
    display: flex;
    flex-direction: column;
    width: 260px;
    height: calc( 100% - 10px );
}

#sidebar.hidden {
    left: -260px;
    margin-right: -260px;
}

#sidebar.hidden .hide-sidebar {
    left: 60px;
    transform: rotate(180deg);
    padding: 15px 13px 11px 13px;
}

button {
    display: block;
    background: inherit;
    border: 1px solid var(--color-border1);
    border-radius: 5px;
    color: var(--color-white);
    padding: 13px;
    box-sizing: border-box;
    text-align: left;
    cursor: pointer;
}

button:hover {
    background: var(--color-button-hover);
}

.sidebar-controls {
    display: flex;
    gap: 10px;
    margin-bottom: 8px;
}

.sidebar-controls button {
    padding: 12px 13px 12px 13px;
}

.hide-sidebar {
    position: relative;
    left: 0;
    top: 0;
    transition: all 0.2s ease-in-out;
    transform: rotate(0deg);
}

.new-chat i {
    margin-right: 13px;
}

.new-chat {
    flex: 1 1;
    height: 3rem;
}

.conversations {
    width: calc( 100% + 8px );
    overflow-y: scroll;
}

.conversations,
.conversations li {
    list-style: none;
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.conversations li {
    position: relative;
}

.conversations li .fa {
    margin-right: 7px;
}

.conversations li > button {
    width: 100%;
    border: none;
    font-size: 0.9em;
    white-space: nowrap;
    overflow: hidden;
}

.conversations li.active > button {
    background: var(--color-main);
}

.edit-buttons {
    display: none;
    margin: auto;
    position: absolute;
    right: 8px;
    top: 0;
    padding: 0px 8px;
    background-color: #9ca6b5;
    border-radius: 10px;
    z-index: 99;
}

.conversations li:hover .edit-buttons {
    display: flex;
}

.fade {
    position: absolute;
    right: 0;
    top: 0;
    background: var(--color-user-icon);
    width: 40px;
    height: 100%;
    border-radius: 5px;
    background: transparent;
    background: linear-gradient(90deg, var(--color-secondary-fade) 0%, var(--color-secondary) 50%);
}

.conversations li.active .fade {
    background: linear-gradient(90deg, var(--color-main-fade) 0%, var(--color-main) 50%);
}

.conversations li:hover .fade {
    width: 80px;
    background: linear-gradient(90deg, var(--color-button-hover-fade) 0%, var(--color-button-hover) 30%);
}

.edit-buttons button {
    border: none;
    padding: 0;
    margin: 13px 1px 13px 1px;
    opacity: 0.7;
}

.edit-buttons button:hover {
    background: none;
    opacity: 1;
}

.conversations li.grouping {
    color: var(--color-groupings);
    font-size: 0.7em;
    font-weight: bold;
    padding-left: 13px;
    margin-top: 12px;
    margin-bottom: 12px;
}

i.user-icon {
    padding: 6px;
    color: var(--color-white);
    background: var(--color-user-icon);
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    margin-right: 6px;
    font-style: normal;
    width: 18px;
    height: 18px;
    font-size: 15px;
    text-transform: uppercase;
    font-family: system-ui, sans-serif;
}

.gpt.user-icon  {
    background: var(--color-gpt-icon);
}

.user-menu {
    position: relative;
    border-top: 1px solid var(--color-border1);
}

.user-menu button {
    width: 100%;
    border: none;
}

.user-menu .dots {
    position: relative;
    top: 11px;
    float: right;
    opacity: 0.7;
}

.user-menu > ul,
.user-menu li {
    list-style: none;
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.user-menu > ul {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transform: translateY(-100%);
    background: var(--color-black);
    border-radius: 10px;
    width: 100%;
    transition: all 0.2s ease-in-out;
}

.user-menu > ul.show-animate {
    display: block;
}

.user-menu > ul.show {
    opacity: 1;
    margin-top: -8px;
}

.user-menu li button {
    border-radius: 0;
}

.user-menu li button:hover {
    background: var(--color-user-menu-hover);
}

.user-menu li:first-child button {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.user-menu li:last-child button {
    border-top: 1px solid var(--color-user-menu-border);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}


main {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: space-between;
    padding: 0 0 30px 0;
    box-sizing: border-box;
}

main .view {
    display: flex;
    flex-direction: column;
}

.model-selector {
    position: relative;
    border-radius: 11px;
    background: var(--color-secondary);
    display: flex;
    padding: 4px;
    gap: 4px;
    margin: 24px auto;
    z-index: 2;
}

.model-selector > button {
    border-radius: 9px;
    text-align: center;
    width: 150px;
    border: none;
    font-weight: bold;
    opacity: 0.5;
}

.model-selector > button:hover {
    background: none;
    opacity: 1;
}

.model-selector > button.selected {
    border: 1px solid var(--color-user-menu-selected-border);
    background: var(--color-user-menu-hover);
    opacity: 1;
}

.model-selector button .fa {
    margin-right: 5px;
}

.gpt-3 .fa {
    color: var(--color-gpt3);
}

.gpt-4 .fa {
    color: var(--color-gpt4);
}

.model-info {
    display: none;
    position: absolute;
    bottom: 5px;
    left: 0;
    transform: translateY(100%);
    padding: 15px;
    cursor: default;
}

.model-info-box {
    padding: 20px 20px 10px 20px;
    border-radius: 15px;
    background: var(--color-secondary);
    color: var(--color-white);
    text-align: left;
}

.model-selector > button:hover .model-info {
    display: block;
}

.model-selector p {
    font-size: 1.1em;
    margin: 0 0 15px 0;
}

p.secondary {
    font-size: 1em;
    color: var(--color-secondary-p);
}

.logo {
    position: relative;
    z-index: 1;
    color: var(--color-logo);
    font-weight: bold;
    text-align: center;
    font-size: 2.3em;
    left: 50;
}

.view.conversation-view {
    display: none;
    overflow-y: auto;
}

.model-name {
    background: var(--color-main);
    text-align: center;
    color: var(--color-model-name);
    padding: 23px;
    border-bottom: 1px solid var(--color-border2);
    font-size: 0.85em;
}

.message {
    display: flex;
    gap: 20px;
    padding: 25px 60px 15px 60px;
    border-bottom: 1px solid var(--color-border2);
    font-size: 0.95em;
}

.message .content {
    padding-top: 5px;
}

.user.message {
    color: var(--color-text);
}

.assistant.message {
    background: var(--color-assistant-bg);
    color: var(--color-assistant-text);
}

#message-form {
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    max-width: 850px;
    text-align: center;
    padding: 0px 45px 0 45px;
    /* box-shadow: var(--color-main) 0 0 50px; */
    z-index: 9999;
    position: fixed;
    bottom:0;
    left: 25%;
    margin-bottom: 10PX;
}

.message-wrapper {
    position: relative;
}

#message::placeholder {
    color: var(--color-groupings);
}

#message {
    background: var(--color-user-menu-hover);
    border-radius: 13px;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid var(--color-user-message-border);
    resize: none;
    padding: 20px 60px 17px 15px;
    font-family: inherit;
    font-size: 1em;
    color: var(--color-white);
    /* box-shadow: rgba(0,0,0,0.2) 0 0 45px; */
    outline: none;
}

.send-button {
    background: var(--color-gpt3);
    border-radius: 5px;
    display: inline-block;
    font-size: 1em;
    color: var(--color-white);
    border: none;
    width: auto;
}

button.send-button:hover {
    border: none;
    background: var(--color-gpt3);
    color: var(--color-white);
}

p {
    margin: 0 0 1.5em 0;
}


/* upcoming outing query */
#message_container{
    padding-top: 4rem;
    width: 100%;
    height:100vh;
    overflow-y: auto;
}


@media screen and (max-width: 600px) {
    #message-form{
        width:300px;
        padding: 0 0 0 0 ;
        left: 15%;
    }
    #message{
        width: 100%;
    }
    main {
        padding: 0 0 0 0 ;
        margin: 0 0 0 0 ;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AI/AskAI/NewAskAI.css"],"names":[],"mappings":";;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,0BAA0B;IAC1B,+BAA+B;IAC/B,6BAA6B;IAC7B,kCAAkC;IAClC,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,0CAA0C;IAC1C,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,cAAc;IACd,kCAAkC;IAClC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,OAAO;IACP,kCAAkC;IAClC,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,8FAA8F;AAClG;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,WAAW;IACX,oGAAoG;AACxG;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;IAElB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,4BAA4B;IAC5B,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,mDAAmD;IACnD,8BAA8B;IAC9B,+BAA+B;AACnC;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,YAAY;IACZ,QAAQ;IACR,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,wDAAwD;IACxD,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,2BAA2B;IAC3B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,4CAA4C;IAC5C,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kDAAkD;IAClD,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;IACpB,cAAc;IACd,yBAAyB;IACzB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,0BAA0B;AAC1B;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":["\n\n:root {\n    --color-white: #fff;\n    --color-main: #031B34;\n    --color-main-fade: #1c3248;\n    --color-secondary: #1c3248;\n    --color-secondary-fade: #02162a;\n    --color-button-hover: #03182f;\n    --color-button-hover-fade: #03182f;\n    --color-user-icon: #8e0000;\n    --color-groupings: #9aa4ae;\n    --color-gpt-icon: #03182f;\n    --color-black: #02101f;\n    --color-user-menu-hover: #4f5f71;\n    --color-text: #f5f9ff;\n    --color-gpt3: #03182f;\n    --color-gpt4: #f22626;\n    --color-secondary-p: #e6e8eb;\n    --color-logo: #cdd1d6;\n    --color-model-name: #e6e8eb;\n    --color-assistant-bg: #9aa4ae;\n    --color-assistant-text: #e6e8eb;\n    --color-disclaimer: #e6e8eb;\n    --color-border1: #35495d;\n    --color-user-menu-border: #010810;\n    --color-user-menu-selected-border: #010810;\n    --color-border2: #010810;\n    --color-user-message-border: #010810;\n}\n\n#askai_mainbody {\n    /* background: var(--color-main); */\n    display: flex;\n    font-size: 1em;\n    font-family: system-ui, sans-serif;\n    height: 100vh;\n    margin-top: 4rem;\n}\n\n#sidebar {\n    position: relative;\n    /* padding-top: 2rem; */\n    left: 0;\n    background: var(--color-secondary);\n    padding: 4rem 0.8rem;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    transition: all 0.3s ease-in-out;\n    /* height: 100vh; */\n}\n\n.float-top {\n    display: flex;\n    flex-direction: column;\n    width: 260px;\n    height: calc( 100% - 10px );\n}\n\n#sidebar.hidden {\n    left: -260px;\n    margin-right: -260px;\n}\n\n#sidebar.hidden .hide-sidebar {\n    left: 60px;\n    transform: rotate(180deg);\n    padding: 15px 13px 11px 13px;\n}\n\nbutton {\n    display: block;\n    background: inherit;\n    border: 1px solid var(--color-border1);\n    border-radius: 5px;\n    color: var(--color-white);\n    padding: 13px;\n    box-sizing: border-box;\n    text-align: left;\n    cursor: pointer;\n}\n\nbutton:hover {\n    background: var(--color-button-hover);\n}\n\n.sidebar-controls {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 8px;\n}\n\n.sidebar-controls button {\n    padding: 12px 13px 12px 13px;\n}\n\n.hide-sidebar {\n    position: relative;\n    left: 0;\n    top: 0;\n    transition: all 0.2s ease-in-out;\n    transform: rotate(0deg);\n}\n\n.new-chat i {\n    margin-right: 13px;\n}\n\n.new-chat {\n    flex: 1;\n    height: 3rem;\n}\n\n.conversations {\n    width: calc( 100% + 8px );\n    overflow-y: scroll;\n}\n\n.conversations,\n.conversations li {\n    list-style: none;\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.conversations li {\n    position: relative;\n}\n\n.conversations li .fa {\n    margin-right: 7px;\n}\n\n.conversations li > button {\n    width: 100%;\n    border: none;\n    font-size: 0.9em;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.conversations li.active > button {\n    background: var(--color-main);\n}\n\n.edit-buttons {\n    display: none;\n    margin: auto;\n    position: absolute;\n    right: 8px;\n    top: 0;\n    padding: 0px 8px;\n    background-color: #9ca6b5;\n    border-radius: 10px;\n    z-index: 99;\n}\n\n.conversations li:hover .edit-buttons {\n    display: flex;\n}\n\n.fade {\n    position: absolute;\n    right: 0;\n    top: 0;\n    background: var(--color-user-icon);\n    width: 40px;\n    height: 100%;\n    border-radius: 5px;\n    background: transparent;\n    background: linear-gradient(90deg, var(--color-secondary-fade) 0%, var(--color-secondary) 50%);\n}\n\n.conversations li.active .fade {\n    background: linear-gradient(90deg, var(--color-main-fade) 0%, var(--color-main) 50%);\n}\n\n.conversations li:hover .fade {\n    width: 80px;\n    background: linear-gradient(90deg, var(--color-button-hover-fade) 0%, var(--color-button-hover) 30%);\n}\n\n.edit-buttons button {\n    border: none;\n    padding: 0;\n    margin: 13px 1px 13px 1px;\n    opacity: 0.7;\n}\n\n.edit-buttons button:hover {\n    background: none;\n    opacity: 1;\n}\n\n.conversations li.grouping {\n    color: var(--color-groupings);\n    font-size: 0.7em;\n    font-weight: bold;\n    padding-left: 13px;\n    margin-top: 12px;\n    margin-bottom: 12px;\n}\n\ni.user-icon {\n    padding: 6px;\n    color: var(--color-white);\n    background: var(--color-user-icon);\n    display: inline-block;\n    text-align: center;\n    width: 15px;\n    border-radius: 3px;\n    margin-right: 6px;\n    font-style: normal;\n    width: 18px;\n    height: 18px;\n    font-size: 15px;\n    text-transform: uppercase;\n    font-family: system-ui, sans-serif;\n}\n\n.gpt.user-icon  {\n    background: var(--color-gpt-icon);\n}\n\n.user-menu {\n    position: relative;\n    border-top: 1px solid var(--color-border1);\n}\n\n.user-menu button {\n    width: 100%;\n    border: none;\n}\n\n.user-menu .dots {\n    position: relative;\n    top: 11px;\n    float: right;\n    opacity: 0.7;\n}\n\n.user-menu > ul,\n.user-menu li {\n    list-style: none;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n\n.user-menu > ul {\n    display: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    transform: translateY(-100%);\n    background: var(--color-black);\n    border-radius: 10px;\n    width: 100%;\n    transition: all 0.2s ease-in-out;\n}\n\n.user-menu > ul.show-animate {\n    display: block;\n}\n\n.user-menu > ul.show {\n    opacity: 1;\n    margin-top: -8px;\n}\n\n.user-menu li button {\n    border-radius: 0;\n}\n\n.user-menu li button:hover {\n    background: var(--color-user-menu-hover);\n}\n\n.user-menu li:first-child button {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.user-menu li:last-child button {\n    border-top: 1px solid var(--color-user-menu-border);\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\n\nmain {\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: space-between;\n    padding: 0 0 30px 0;\n    box-sizing: border-box;\n}\n\nmain .view {\n    display: flex;\n    flex-direction: column;\n}\n\n.model-selector {\n    position: relative;\n    border-radius: 11px;\n    background: var(--color-secondary);\n    display: flex;\n    padding: 4px;\n    gap: 4px;\n    margin: 24px auto;\n    z-index: 2;\n}\n\n.model-selector > button {\n    border-radius: 9px;\n    text-align: center;\n    width: 150px;\n    border: none;\n    font-weight: bold;\n    opacity: 0.5;\n}\n\n.model-selector > button:hover {\n    background: none;\n    opacity: 1;\n}\n\n.model-selector > button.selected {\n    border: 1px solid var(--color-user-menu-selected-border);\n    background: var(--color-user-menu-hover);\n    opacity: 1;\n}\n\n.model-selector button .fa {\n    margin-right: 5px;\n}\n\n.gpt-3 .fa {\n    color: var(--color-gpt3);\n}\n\n.gpt-4 .fa {\n    color: var(--color-gpt4);\n}\n\n.model-info {\n    display: none;\n    position: absolute;\n    bottom: 5px;\n    left: 0;\n    transform: translateY(100%);\n    padding: 15px;\n    cursor: default;\n}\n\n.model-info-box {\n    padding: 20px 20px 10px 20px;\n    border-radius: 15px;\n    background: var(--color-secondary);\n    color: var(--color-white);\n    text-align: left;\n}\n\n.model-selector > button:hover .model-info {\n    display: block;\n}\n\n.model-selector p {\n    font-size: 1.1em;\n    margin: 0 0 15px 0;\n}\n\np.secondary {\n    font-size: 1em;\n    color: var(--color-secondary-p);\n}\n\n.logo {\n    position: relative;\n    z-index: 1;\n    color: var(--color-logo);\n    font-weight: bold;\n    text-align: center;\n    font-size: 2.3em;\n    left: 50;\n}\n\n.view.conversation-view {\n    display: none;\n    overflow-y: auto;\n}\n\n.model-name {\n    background: var(--color-main);\n    text-align: center;\n    color: var(--color-model-name);\n    padding: 23px;\n    border-bottom: 1px solid var(--color-border2);\n    font-size: 0.85em;\n}\n\n.message {\n    display: flex;\n    gap: 20px;\n    padding: 25px 60px 15px 60px;\n    border-bottom: 1px solid var(--color-border2);\n    font-size: 0.95em;\n}\n\n.message .content {\n    padding-top: 5px;\n}\n\n.user.message {\n    color: var(--color-text);\n}\n\n.assistant.message {\n    background: var(--color-assistant-bg);\n    color: var(--color-assistant-text);\n}\n\n#message-form {\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n    max-width: 850px;\n    text-align: center;\n    padding: 0px 45px 0 45px;\n    /* box-shadow: var(--color-main) 0 0 50px; */\n    z-index: 9999;\n    position: fixed;\n    bottom:0;\n    left: 25%;\n    margin-bottom: 10PX;\n}\n\n.message-wrapper {\n    position: relative;\n}\n\n#message::placeholder {\n    color: var(--color-groupings);\n}\n\n#message {\n    background: var(--color-user-menu-hover);\n    border-radius: 13px;\n    width: 100%;\n    box-sizing: border-box;\n    border: 1px solid var(--color-user-message-border);\n    resize: none;\n    padding: 20px 60px 17px 15px;\n    font-family: inherit;\n    font-size: 1em;\n    color: var(--color-white);\n    /* box-shadow: rgba(0,0,0,0.2) 0 0 45px; */\n    outline: none;\n}\n\n.send-button {\n    background: var(--color-gpt3);\n    border-radius: 5px;\n    display: inline-block;\n    font-size: 1em;\n    color: var(--color-white);\n    border: none;\n    width: auto;\n}\n\nbutton.send-button:hover {\n    border: none;\n    background: var(--color-gpt3);\n    color: var(--color-white);\n}\n\np {\n    margin: 0 0 1.5em 0;\n}\n\n\n/* upcoming outing query */\n#message_container{\n    padding-top: 4rem;\n    width: 100%;\n    height:100vh;\n    overflow-y: auto;\n}\n\n\n@media screen and (max-width: 600px) {\n    #message-form{\n        width:300px;\n        padding: 0 0 0 0 ;\n        left: 15%;\n    }\n    #message{\n        width: 100%;\n    }\n    main {\n        padding: 0 0 0 0 ;\n        margin: 0 0 0 0 ;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
